export const ExcelIcon = ({ className, color = "currentcolor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill={color} className={className}><path d="M 28.8125 0.03125 L 0.8125 5.34375 C 0.339844 5.433594 0 5.863281 0 6.34375 L 0 43.65625 C 0 44.136719 0.339844 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 28.875 49.980469 28.9375 50 29 50 C 29.230469 50 29.445313 49.929688 29.625 49.78125 C 29.855469 49.589844 30 49.296875 30 49 L 30 1 C 30 0.703125 29.855469 0.410156 29.625 0.21875 C 29.394531 0.0273438 29.105469 -0.0234375 28.8125 0.03125 Z M 32 6 L 32 13 L 34 13 L 34 15 L 32 15 L 32 20 L 34 20 L 34 22 L 32 22 L 32 27 L 34 27 L 34 29 L 32 29 L 32 35 L 34 35 L 34 37 L 32 37 L 32 44 L 47 44 C 48.101563 44 49 43.101563 49 42 L 49 8 C 49 6.898438 48.101563 6 47 6 Z M 36 13 L 44 13 L 44 15 L 36 15 Z M 6.6875 15.6875 L 11.8125 15.6875 L 14.5 21.28125 C 14.710938 21.722656 14.898438 22.265625 15.0625 22.875 L 15.09375 22.875 C 15.199219 22.511719 15.402344 21.941406 15.6875 21.21875 L 18.65625 15.6875 L 23.34375 15.6875 L 17.75 24.9375 L 23.5 34.375 L 18.53125 34.375 L 15.28125 28.28125 C 15.160156 28.054688 15.035156 27.636719 14.90625 27.03125 L 14.875 27.03125 C 14.8125 27.316406 14.664063 27.761719 14.4375 28.34375 L 11.1875 34.375 L 6.1875 34.375 L 12.15625 25.03125 Z M 36 20 L 44 20 L 44 22 L 36 22 Z M 36 27 L 44 27 L 44 29 L 36 29 Z M 36 35 L 44 35 L 44 37 L 36 37 Z" /></svg>
);

export const WordIcon = ({ className, color = "currentcolor" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" fill={color} className={className} viewBox="0 0 50 50">
        <path d="M 28.8125 0.03125 L 0.8125 5.34375 C 0.339844 5.433594 0 5.863281 0 6.34375 L 0 43.65625 C 0 44.136719 0.339844 44.566406 0.8125 44.65625 L 28.8125 49.96875 C 28.875 49.980469 28.9375 50 29 50 C 29.230469 50 29.445313 49.929688 29.625 49.78125 C 29.855469 49.589844 30 49.296875 30 49 L 30 1 C 30 0.703125 29.855469 0.410156 29.625 0.21875 C 29.394531 0.0273438 29.105469 -0.0234375 28.8125 0.03125 Z M 32 6 L 32 13 L 44 13 L 44 15 L 32 15 L 32 20 L 44 20 L 44 22 L 32 22 L 32 27 L 44 27 L 44 29 L 32 29 L 32 35 L 44 35 L 44 37 L 32 37 L 32 44 L 47 44 C 48.101563 44 49 43.101563 49 42 L 49 8 C 49 6.898438 48.101563 6 47 6 Z M 4.625 15.65625 L 8.1875 15.65625 L 10.21875 28.09375 C 10.308594 28.621094 10.367188 29.355469 10.40625 30.25 L 10.46875 30.25 C 10.496094 29.582031 10.613281 28.855469 10.78125 28.0625 L 13.40625 15.65625 L 16.90625 15.65625 L 19.28125 28.21875 C 19.367188 28.679688 19.433594 29.339844 19.5 30.21875 L 19.53125 30.21875 C 19.558594 29.53125 19.632813 28.828125 19.75 28.125 L 21.75 15.65625 L 25.0625 15.65625 L 21.21875 34.34375 L 17.59375 34.34375 L 15.1875 22.375 C 15.058594 21.75 14.996094 21.023438 14.96875 20.25 L 14.9375 20.25 C 14.875 21.101563 14.769531 21.824219 14.65625 22.375 L 12.1875 34.34375 L 8.4375 34.34375 Z"></path>
    </svg>
);

export const AudioIcon = ({ className, color = "currentcolor" }) => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 300.000000 146.000000"
        preserveAspectRatio="xMidYMid meet"
        className={className}>

        <g transform="translate(0.000000,146.000000) scale(0.100000,-0.100000)"
            fill={color} stroke="none">
            <path d="M690 718 l0 -648 40 0 40 0 0 649 0 648 -40 -1 -40 -1 0 -647z" />
            <path d="M1650 719 l0 -649 40 0 40 0 0 649 0 648 -40 0 -40 0 0 -648z" />
            <path d="M500 715 l0 -525 40 0 40 0 0 525 0 525 -40 0 -40 0 0 -525z" />
            <path d="M880 715 l0 -525 40 0 40 0 0 525 0 525 -40 0 -40 0 0 -525z" />
            <path d="M1458 715 l2 -525 40 0 40 0 0 525 0 525 -42 0 -43 0 3 -525z" />
            <path d="M1840 715 l0 -525 40 0 40 0 0 525 0 525 -40 0 -40 0 0 -525z" />
            <path d="M2417 718 l3 -523 40 -3 40 -3 0 525 0 526 -42 0 -43 0 2 -522z" />
            <path d="M310 1096 c0 -1 -1 -171 -3 -379 l-2 -377 43 0 42 0 -2 376 -3 376
-37 3 c-21 1 -38 1 -38 1z"/>
            <path d="M1075 1092 c-3 -3 -5 -173 -5 -379 l0 -373 43 0 42 0 -2 377 -3 377
-35 2 c-19 0 -37 -1 -40 -4z"/>
            <path d="M2030 718 l0 -378 40 0 40 0 0 370 c0 204 -1 373 -2 377 -2 4 -20 8
-40 8 l-38 1 0 -378z"/>
            <path d="M2610 718 l0 -378 40 0 40 0 0 378 0 377 -40 0 -40 0 0 -377z" />
            <path d="M1265 720 l0 -280 40 0 40 0 0 280 0 280 -40 0 -40 0 0 -280z" />
            <path d="M2225 720 l0 -280 40 0 40 0 0 280 0 280 -40 0 -40 0 0 -280z" />
            <path d="M110 721 l0 -151 43 0 42 0 -2 147 -2 148 -41 3 -40 3 0 -150z" />
            <path d="M2800 720 l0 -150 40 0 40 0 0 150 0 150 -40 0 -40 0 0 -150z" />
        </g>
    </svg>
);

export const ImageIcon = ({ className, color = "currentColor" }) => (
    <svg
        className={className}
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <rect x="1" y="1" width="22" height="16" rx="2" ry="2" />
        <circle cx="8" cy="9" r="2" />
        <path d="M21 13l-5-5L5 17" />
    </svg>
);

export const PdfIcon = ({ className, color = "currentColor" }) => (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="300.000000pt" height="300.000000pt" viewBox="0 0 300.000000 300.000000"
        preserveAspectRatio="xMidYMid meet"
        className={className}
    >

        <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)"
            fill={color} stroke="none">
            <path d="M494 2892 c-33 -21 -34 -50 -34 -665 l0 -615 -76 -4 c-73 -3 -77 -5
-110 -41 l-34 -37 0 -412 c1 -317 4 -418 14 -436 24 -43 65 -62 139 -62 l67 0
0 -231 c0 -226 4 -262 34 -281 14 -10 1998 -10 2012 0 30 19 34 55 34 281 l0
231 68 0 c73 0 114 19 138 62 10 18 13 119 14 436 l0 412 -34 37 c-33 36 -37
38 -110 41 l-76 4 0 311 0 312 -333 332 -332 333 -685 0 c-377 0 -690 -4 -696
-8z m1266 -374 c0 -283 6 -310 74 -356 54 -37 94 -42 344 -42 l232 0 0 -255 0
-255 -910 0 -910 0 0 580 0 580 585 0 585 0 0 -252z m568 -260 c2 -5 -86 -8
-195 -8 -164 0 -202 3 -221 16 -22 15 -22 20 -22 221 l0 206 218 -214 c119
-117 219 -217 220 -221z m-1333 -762 c157 -67 198 -270 79 -390 -53 -52 -100
-69 -211 -74 l-103 -5 0 -143 c0 -131 -2 -146 -20 -164 -24 -24 -29 -24 -58
-4 l-22 15 0 379 0 379 23 16 c31 23 253 17 312 -9z m595 0 c62 -22 137 -81
177 -139 123 -181 85 -452 -83 -579 -72 -56 -121 -69 -266 -75 -108 -5 -131
-3 -153 11 l-25 16 0 380 0 379 23 16 c19 14 42 16 152 12 81 -3 147 -11 175
-21z m770 11 c34 -17 39 -60 8 -81 -18 -13 -51 -16 -170 -16 l-148 0 0 -110 0
-110 113 0 c124 0 157 -12 157 -55 0 -43 -33 -55 -157 -55 l-113 0 0 -170 c0
-157 -2 -172 -20 -190 -24 -24 -29 -24 -58 -4 l-22 15 0 379 0 379 22 15 c29
21 348 23 388 3z m50 -1082 l0 -195 -910 0 -910 0 0 195 0 195 910 0 910 0 0
-195z"/>
            <path d="M760 1275 l0 -135 99 0 c85 0 102 3 125 21 77 61 74 180 -7 229 -26
16 -50 20 -124 20 l-93 0 0 -135z"/>
            <path d="M1340 1110 l0 -300 98 0 c113 0 156 16 214 76 61 64 83 125 82 224 0
105 -26 171 -91 231 -63 58 -97 69 -208 69 l-95 0 0 -300z"/>
        </g>
    </svg>

);